// @core/api/endpoints/activity/update_mapping_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  MappingConfigResponse,
  UpdateMappingConfigRequest,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * Update activity mapping config
 * Updates an existing Kafka topic → Activity mapping configuration.
 */
export async function UpdateMappingConfig(
  id: string,
  data: UpdateMappingConfigRequest,
  options?: RequestOptions
): Promise<MappingConfigResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/activity-mappings/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.put<MappingConfigResponse>(requestPath, data, requestOptions);
}
